export default __webpack_public_path__ + "static/media/273.1fff615b.jpg";